"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColonyName = void 0;
var ColonyName;
(function (ColonyName) {
    ColonyName["CALLISTO"] = "Callisto";
    ColonyName["CERES"] = "Ceres";
    ColonyName["ENCELADUS"] = "Enceladus";
    ColonyName["EUROPA"] = "Europa";
    ColonyName["GANYMEDE"] = "Ganymede";
    ColonyName["IO"] = "Io";
    ColonyName["LUNA"] = "Luna";
    ColonyName["MIRANDA"] = "Miranda";
    ColonyName["PLUTO"] = "Pluto";
    ColonyName["TITAN"] = "Titan";
    ColonyName["TRITON"] = "Triton";
    ColonyName["IAPETUS"] = "Iapetus";
    ColonyName["MERCURY"] = "Mercury";
    ColonyName["HYGIEA"] = "Hygiea";
    ColonyName["TITANIA"] = "Titania";
    ColonyName["VENUS"] = "Venus";
    ColonyName["LEAVITT"] = "Leavitt";
    ColonyName["PALLAS"] = "Pallas";
    ColonyName["LEAVITT_II"] = "Leavitt II";
    ColonyName["IAPETUS_II"] = "Iapetus II";
})(ColonyName = exports.ColonyName || (exports.ColonyName = {}));
